package ru.it_mozaika.sender.js.application.components

import mui.icons.material.Cancel
import mui.material.*
import mui.system.sx
import react.FC
import react.ReactNode
import react.create
import react.useMemo
import ru.it_mozaika.sender.js.application.context.useSubscriptionLists
import web.cssom.Display
import web.cssom.FlexWrap
import web.cssom.px

external interface SubscriptionListSelectProps:FormControlProps{
    var setFullWidth: Boolean?
    var isDisabled: Boolean?

}

val SubscriptionListSelect = FC<SubscriptionListSelectProps> { props ->
    val context = useSubscriptionLists()
    val lists = useMemo(context.lists) {
        context.lists.associate { it.id to it.name }
    }
    val selected = useMemo(context.lists, context.currentIds) {
        context.currentLists().associate {
            it.id to it.name
        }
    }

    FormControl {

        sx { minWidth = 200.px }
        fullWidth = props.setFullWidth ?: true
        InputLabel {
            id = "subscription-list-select-label"
            +"Подписка:"
        }
        Select {
            error = selected.isEmpty()
            color = InputBaseColor.secondary
            labelId = "subscription-list-select-label"
            id = "subscription-list-select"
            value = context.currentIds.toTypedArray()
            label = ReactNode("Подписки:")
            multiple = context.isMultiple
            disabled = props.isDisabled ?: false
            onChange = onChange@{ e, _ ->
                if (context.isMultiple) {
                    val ids = e.target.value.unsafeCast<Array<String>>()
                    context.setCurrentIds(ids.toSet())
                } else {
                    context.setCurrentIds(setOf(e.target.value))
                }
            }
            if (context.isMultiple) {
                renderValue = useMemo(selected) {{ _ ->
                    Box.create {
                        sx {
                            display = Display.flex
                            flexWrap = FlexWrap.wrap
                            asDynamic().gap = 0.5
                        }

                        selected.forEach { (id, title) ->
                            Chip {
                                deleteIcon = Cancel.create {
                                    onMouseDown = {
                                        it.stopPropagation()
                                    }
                                }
                                onDelete = {
                                    context.toggleCurrentId(id)
                                }

                                key = id
                                label = ReactNode(title)
                            }
                        }
                    }
                }}
            }
            lists.forEach { (id, title) ->
                MenuItem {
                    this.selected = selected.contains(id)
                    Checkbox{
                        color = CheckboxColor.secondary
                        checked = selected.contains(id)
                    }
                    value = id
                    +title
                }
            }
        }
    }
}